// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-3c5d01cb] .el-form-item {\n  margin-bottom: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
